import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import useParticipants from "../useParticipants/useParticipants";
import Participant from "../Participant/Participant";
import useMainParticipant from "../../hooks/useMainParticipant/useMainParticipant";
import useSelectedParticipant from "../../hooks/useSelectedParticipant/useSelectedParticipant";

const useStyles = makeStyles(() => {
  return {
    container: {
      overflowY: "auto",
      //   background: "rgb(79, 83, 85)",
      gridArea: "1 / 2 / 1 / 3",
      zIndex: 5,
    },
    transparentBackground: {
      background: "transparent",
    },
    scrollContainer: {
      display: "flex",
      justifyContent: "center",
    },
    innerScrollContainer: {
      width: `calc(300px - 3em)`,
      padding: "1.5em 0",
    },
  };
});

const ParticipantList: React.FC<any> = ({ room }) => {
  const classes = useStyles();
  //   const { room } = window;
  const localParticipant = room?.localParticipant;
  const participants = useParticipants(room);
  const [selectedParticipant, setSelectedParticipant] =
    useSelectedParticipant();
  const mainParticipant = useMainParticipant(room);

  if (participants.length === 0) return null;
  return (
    <aside className={clsx(classes.container)}>
      <div className={classes.scrollContainer}>
        <div className={classes.innerScrollContainer}>
          <Participant
            participant={localParticipant}
            isLocalParticipant={true}
            room={room}
          />
          {participants.map((participant: any, index) => {
            const isSelected = participant === selectedParticipant;
            const hideParticipant =
              participant === mainParticipant && !isSelected;
            return (
              <Participant
                key={index}
                participant={participant}
                hideParticipant={hideParticipant}
                onClick={() => setSelectedParticipant(participant)}
                room={room}
              />
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default ParticipantList;
